import { TabBookingAbstract } from './tabBookingAbstract'
import { poItemsUpdate } from '@/api/seaExport/poItems'
import { PoItems } from '@/class/model/booking/PoItems'
import { ExportUtils } from '@/class/cargo/model/utils/ExportUtils'
import { exportExcel } from '@/utils/tableDataExportUtils'
import { cache } from '@/utils/cacheManager'
import { IntegratedJob } from '@/class/model/booking/IntegratedJob'
import URL from '@/api/urlTranslator'

export class TabTradeDetailBase extends TabBookingAbstract {
  /**
   * @param {Object} view 视图
   */
  constructor(view) {
    super(view)
    this.$message = this.view.$message
    this.$confirm = this.view.$confirm
    this.$refs = this.view.$refs
    this.$store = this.view.$store
    this.$i18n = this.view.$i18n
    this.$emit = this.view.$emit
    this.view.$t = this.view.$t
    this.$checkPermission = this.view.$checkPermission
  }

  get context() {
    return this.view.context
  }

  set context(context) {
    this.view.context = context
  }

  get user() {
    return this.view.context.user
  }

  set user(user) {
    this.view.context.user = user
  }

  get config() {
    return this.view.config
  }

  set config(config) {
    this.view.config = config
  }

  get job() {
    return this.view.job
  }

  set job(job) {
    this.view.job = job
  }

  get poItems() {
    return this.view.poItems
  }

  set poItems(poItems) {
    this.view.poItems = poItems
  }

  get delPoItemsUuids() {
    return this.view.delPoItemsUuids
  }

  set delPoItemsUuids(delPoItemsUuids) {
    this.view.delPoItemsUuids = delPoItemsUuids
  }

  async loadPoItems(isRefresh = false) {
    // 加载数据
    const job = new IntegratedJob(this.job)

    // 添加/移除装箱 需要强制刷新grid
    if (isRefresh) {
      job.poItems = ''
      job.containerUsages = ''
    }

    await Promise.all([
      job.getPoItems(),
      job.getContainerUsages()
    ])
    this.poItems = this.job.poItems && this.job.poItems.length > 0 ? this.job.poItems.sort((a, b) => {
      return a.sequenceNo - b.sequenceNo
    }) : []
  }
  // 新增
  addBtnClickHandler() {
    const poItems = new PoItems().fillDefaultValue().getData()
    poItems.purchaseCurrency = 'USD'
    poItems.deviceStatus = 0
    poItems.productiveYear = '不详'
    poItems.newOrUsed = ''
    poItems.jobUuid = this.job.uuid
    poItems.sequenceNo = this.poItems.length > 0 ? this.poItems.length + 1 : 1
    if (this.poItems) {
      if (this.poItems.length > 0) {
        const lastPoItems = this.poItems[0]
        if (lastPoItems) { poItems.purchaseCurrency = lastPoItems.purchaseCurrency }
      }
    }
    this.poItems.push(poItems)
    // gird 刷新
    // this.view.$nextTick(() => {
    //   this.view.gridApi.refreshCells({ force: true })
    // })
  }
  // 删除
  delBtnClickHandler() {
    const selections = this.view.gridApi.getSelectedRows()
    if (selections.length > 0) {
      for (const item of selections) {
        if (item.uuid) {
          this.delPoItemsUuids.push(item.uuid)
        }
        const index = this.poItems.findIndex(p => p === item)
        this.poItems.splice(index, 1)
        this.updateSequenceNo(item.sequenceNo)
      }
    }
  }
  // button click 关联装箱信息
  relatedContainerHandler() {
    // 获取选中项
    var selPoItems = this.view.gridApi.getSelectedRows()

    if (selPoItems == null || selPoItems.length === 0) {
      this.$message.warning(this.view.$t('Message.CargoDetailsIsNotSelected'))
      return
    } else {
      for (const item of selPoItems) {
        if (item.related === 1) {
          this.$message.warning(this.view.$t('Message.PleaseSelectUnRelatedTradeDetailData'))
          return
        }
      }
    }
    const containerUsageKeys = []
    for (const keyItem of this.poItems) {
      if (keyItem.containerUsageKey && !containerUsageKeys.includes(keyItem.containerUsageKey)) {
        containerUsageKeys.push(keyItem.containerUsageKey)
      }
    }

    this.view.tradeDetailContainerLinkedDialog.selPoItems = selPoItems
    this.view.tradeDetailContainerLinkedDialog.relatedContainerUsage = containerUsageKeys
    this.view.tradeDetailContainerLinkedDialog.visible = true
  }
  // 关联装箱信息 处理
  async linkUsagesEventHandler(data) {
    const linkedContainerUsage = data
    const selectedPoItems = this.view.gridApi.getSelectedRows()
    if (selectedPoItems && selectedPoItems.length > 0) {
      for (const item of selectedPoItems) {
        if (linkedContainerUsage.container) {
          item.eqSize = linkedContainerUsage.container.eqSize
          item.eqType = linkedContainerUsage.container.eqType
          item.containerNo = linkedContainerUsage.container.containerNo
          item.sealNo = linkedContainerUsage.container.sealNo
          item.related = 1
          item.containerUsageKey = linkedContainerUsage.uuid
        }
      }
      await poItemsUpdate(selectedPoItems)
      this.$message.success(this.view.$t('Message.OperationSuccessfully'))
      // 刷新grid
      this.loadPoItems(true)
    }
  }

  /**
   * button click 移除关联
   */
  removeRelatedContainerHandler() {
    const selTrades = this.view.gridApi.getSelectedRows()
    if (selTrades == null || selTrades.length === 0) {
      this.$message.warning(this.view.$t('Message.PleaseSelectData'))
      return
    } else if (selTrades.length > 1) {
      this.$message.warning(this.view.$t('Message.OnlySelectOneData'))
      return
    } else {
      const sel = selTrades[0]
      const selContainerUsageKey = sel.containerUsageKey
      const datas = this.poItems
      if (!sel.containerUsageKey) {
        this.$message.warning(this.view.$t('Message.NoAssociatedContainerInfo'))
        return
      }
      const associatePoItems = []
      this.$confirm(this.view.$t('SeaExport.ConatainerNoRemoveRelation').replace('{0}', sel.containerNo), this.view.$t('common.tips.prompt'), {
        confirmButtonText: this.view.$t('common.btn.ok'),
        cancelButtonText: this.view.$t('common.btn.cancel'),
        type: 'warning'
      }).then(async() => {
        for (const poItem of datas) {
          if (poItem.containerUsageKey === selContainerUsageKey) {
            poItem.eqSize = null
            poItem.eqType = null
            poItem.containerNo = null
            poItem.sealNo = null
            poItem.related = 0
            poItem.containerUsageKey = null
            associatePoItems.push(poItem)
          }
        }
        if (associatePoItems && associatePoItems.length > 0) {
          await poItemsUpdate(associatePoItems)
          this.$message.success(this.view.$t('Message.RemovedSuccesfully'))
          // 刷新grid
          this.loadPoItems(true)
        }
      })
    }
  }

  /**
   * 下载模板
   */
  downTemplateBtn_clickHandler() {
    const fileName = 'PoItemsImportTemplate.xls'
    const folderName = 'price'
    ExportUtils.downloadTemplateFile(fileName, folderName)
  }
  //  excel 导入后逻辑处理
  onImportSucceeded(data) {
    const resultDocumentId = data.resultDocumentId
    const successRow = data.successRow
    const errorRow = data.errorRow
    const poItemsList = data.poItemsList
    for (const item of poItemsList) {
      item.sequenceNo = this.poItems.length + 1
      this.poItems.push(item)
    }
    const storageURL = cache.config.get('StorageURL')
    console.log('storageURL -------------- ' + storageURL)
    const url = `${URL.common.findByFileId}/${resultDocumentId}?sessionId=${this.$store.getters.userInfo.sessionId}`
    if (errorRow > 0) {
      this.$confirm(this.view.$t('Message.ImportSuccessful1') + successRow + `${this.view.$t('CargoMsg.Cargo_Pcst')}，${this.view.$t('Message.Failure')}` + errorRow + `${this.view.$t('CargoMsg.Cargo_Pcst')}，${this.view.$t('SeaExport.ReImportAfterModification')}` +
        '<br><a href="' + url + `" target="_blank" style="color:#46a6ff" >${this.view.$t('SeaExport.FailedToDownloadData')}</a>`, this.view.$t('common.tips.systemPrompt'), {
        confirmButtonText: this.view.$t('common.btn.ok'),
        dangerouslyUseHTMLString: true,
        showCancelButton: false,
        closeOnClickModal: false
      }).then(() => {}).catch(() => {})
    }
    // this.$message.success(this.view.$t('Message.ImportSuccessful1') + count + this.view.$t('Message.ImportSuccessful2'))
  }
  /**
   * Excel 导出
   */
  exportBtnClickHandler() {
    if (!this.view.poItems || this.view.poItems.length <= 0) {
      this.$message.warning(this.view.$t('Message.NoData')) // 判断列表是否有数据
      return
    }
    const rows = this.view.gridApi.getSelectedRows()
    if (rows.length === 0) {
      this.$message.warning(this.view.$t('Message.SelectTheData')) // 判断是否选中数据
      return
    }
    const allDisplayedColumns = this.view.gridOptions.columnApi.getAllDisplayedColumns()
    const fileName = '综合物流货物明细'
    exportExcel(fileName, rows, allDisplayedColumns)
  }
  /**
   * 打印
   */
  onBatchPrint() {
    const selectedPoItems = this.view.gridApi.getSelectedRows()
    if (selectedPoItems.length === 0) {
      this.$message.warning(this.view.$t('Message.CargoDetailsIsNotSelected'))
      return
    }
    const uids = Array.from(selectedPoItems, j => j.uuid)
    if (uids.length > 0) {
      this.view.templateSelectorDialog.cxt = new IntegratedJob(this.view.job)
      this.view.templateSelectorDialog.data = { 'POITEMS_UUID': uids }
      this.view.templateSelectorDialog.category = 'IEPOITEMS'
      this.view.templateSelectorDialog.visible = true
    }
  }

  // 修改每行序列号
  updateSequenceNo(sequenceNo) {
    const poItems = this.poItems
    if (poItems && poItems.length > 0) {
      for (const item of poItems) {
        if (item.sequenceNo > sequenceNo) {
          item.sequenceNo = item.sequenceNo - 1
        }
      }
    }
  }
}
